import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import "../../../assets/scss/pages/IntegrationPage.scss";
import Navbar from "./navbar";
import Footer from "./footer";

// Assume these imports are correctly set up in your project
import weighbridge from "../../../assets/images/clients/weighbridge.png";
import tally from "../../../assets/images/clients/tally.png";
import rfid from "../../../assets/images/clients/rfid.png";
import epabx from "../../../assets/images/clients/epabx.jpg";
import attendance from "../../../assets/images/clients/attendance.png";
import secureye from "../../../assets/images/clients/secureye.png";
import client1 from "../../../assets/images/clients/client-1.png";
import client2 from "../../../assets/images/clients/client-2.png";
import client3 from "../../../assets/images/clients/client-3.jpg";
import client4 from "../../../assets/images/clients/client-4.png";
import client5 from "../../../assets/images/clients/client-5.png";
import client6 from "../../../assets/images/clients/client-6.png";

import { FaBalanceScale, FaFileInvoiceDollar, FaBarcode, FaMoneyCheckAlt, FaFingerprint, FaKey, FaPhoneAlt } from "react-icons/fa";

const integrations = [
  {
    title: "Weigh Bridge Integrations",
    image: [weighbridge, tally, attendance],
    logo: FaBalanceScale,
    content: [
      "SMEs not even think to systemize their business operations without integration with WeighBridges.",
      "Zero the chance of revenue leakage being done by weighment operator in your organization.",
    ],
  },
  {
    title: "Accounting Integrations",
    image: [weighbridge, tally, attendance],
    logo: FaFileInvoiceDollar,
    content: [
      "Push your vouchers into Tally as well as other accounting software with ease.",
      "Save time and eliminate manual errors. Easily collaborate with tax practitioners for return filing.",
    ],
  },
  {
    title: "RFID Integrations",
    image: [weighbridge, tally, attendance],
    logo: FaBarcode,
    content: [
      "Our Hotel PMS is ready to work with RFID cards.",
      "You can manage your food court with Prepaid RFID card POS System.",
      "With a very cost-effective solution you can prevent revenue loss in your organisation.",
    ],
  },
  {
    title: "Payment Integrations",
    logo: FaMoneyCheckAlt,
    content: [
      "Give your customers the freedom to pay online.",
      "Our ERP provides integrations with multiple leading online payment service providers.",
      "Accept online payments from the popular digital wallets without any hassles.",
    ],
    clients: [client1, client2, client3, client4, client5, client6],
  },
  {
    title: "Attendance Machine Integrations",
    image: [attendance],
    logo: FaFingerprint,
    content: [
      "Tell your Employees to touch their finger once or use face recognition with attendance machines.",
      "Leave rest on us. Do not waste time to prepare salary statement by manual attendance. Easily monitor employee's activity.",
    ],
  },
  {
    title: "Room Lock Integrations",
    image: [secureye],
    logo: FaKey,
    content: [
      "Integrate your key card programmer with hotel PMS.",
      "Control your room lock with our PMS. No need to double the check-in/check-out entry with another software.",
    ],
  },
  {
    title: "EPABX Integrations",
    image: [epabx],
    logo: FaPhoneAlt,
    content: [
      "Integrate your Telephone EPABX System with hotel PMS.",
      "Let auto download the SMDR data to the server. And save revenue by controlling telephone misuse.",
    ],
  },
];

const IntegrationCard = ({ integration }) => {
  const isPaymentIntegration = integration.title === "Payment Integrations";

  // State for the image slider
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    if (integration.image && integration.image.length > 1) {
      const interval = setInterval(() => {
        setCurrentImageIndex((prevIndex) =>
          prevIndex === integration.image.length - 1 ? 0 : prevIndex + 1
        );
      }, 2000); // Change image every 2 seconds

      return () => clearInterval(interval);
    }
  }, [integration.image]);

  return (
    <div
      className={`integration-item ${isPaymentIntegration ? "payment-integration" : ""}`}
      style={{
        border: "1px solid #ddd",
        borderRadius: "8px",
        padding: "16px",
        textAlign: "center",
        margin: "16px",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      }}
    >
      {!isPaymentIntegration && (
        <div
          className="integration-image"
          style={{
            width: "200px", // Set a fixed width for all integration images
            height: "300px", // Set a fixed height to maintain uniform size
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "space-between",
            overflow: "hidden", // Prevent image overflow
            borderRadius: "10px", // Add a slight border radius for rounded corners
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)", // Apply shadow to the whole container
          }}
        >
          <div
            className="integration-logo"
            style={{
              height: "25%", // Logo takes 25% of the container's height
              width: "60px", // Fixed width for the logo
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "40px",
              color: "#007bff",
              border: "2px solid #007bff",
              borderRadius: "50%", // Circular logo
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            }}
          >
            <integration.logo />
          </div>
          <img
  src={integration.image[currentImageIndex]}
  alt={integration.title}
  style={{
    height: "100%", // Ensure the image takes the full height of the container
    width: "100%", // Ensure the image takes the full width of the container
    objectFit: "contain", // Scale the image to fit within the container without cropping
    borderRadius: "10px", // Rounded corners for the image
  }}
/>

        </div>
      )}

      <div className="integration-card">
        <h2 style={{ fontSize: "1.5rem", marginBottom: "16px" }}>
          {integration.title}
        </h2>
        <ul style={{ listStyle: "none", paddingLeft: "0" }}>
          {integration.content.map((item, i) => (
            <li
              key={i}
              style={{
                marginBottom: "8px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <span
                style={{
                  color: "green",
                  fontWeight: "bold",
                  marginRight: "8px",
                }}
              >
                ✓
              </span>
              {item}
            </li>
          ))}
        </ul>

        <h2 style={{ fontSize: "1.25rem", marginTop: "16px" }}>Use Cases-</h2>
      </div>
      {isPaymentIntegration && (
        <div className="client-logos" style={{ marginTop: "16px" }}>
          {integration.clients.map((client, index) => (
            <img
              key={index}
              src={client}
              alt={`Client ${index + 1}`}
              style={{
                width: "60px",
                height: "auto",
                margin: "8px",
                borderRadius: "4px",
              }}
            />
          ))}
        </div>
      )}
    </div>
  );
};

const IntegrationPage = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div>
      <Navbar />
      <div className="integration-page">
        <div className="container">
          <motion.h1
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <br />
            <br />
            Our Integrations
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: -30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            See what we can Integrate
          </motion.p>

          <div className="integration-list" style={{ display: "flex", flexWrap: "wrap" }}>
            {integrations.map((integration, index) => (
              <IntegrationCard
                key={integration.title}
                integration={integration}
              />
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default IntegrationPage;
